<template>
  <BLayoutList
    :title="pageTitle"
    :create-route="createRoute"
    :skeleton="isLoadingAsyncData"
  >
    <template v-if="selected.length" #before-add>
      <BMenuMore
        :list="menuSelected"
        class="mr-2"
        @selected="onSelectMenu"
      />
    </template>

    <template #filter>
      <ComponentFilter
        :data="filters"
        :skeleton="isLoadingAsyncData"
        @change="onChangeFilter"
      />
    </template>

    <BTableCommon
      v-model="selected"
      type="topics"
      :list="list"
      :pagination="pagination"
      :ordering="filters.ordering"
      :loading="isLoading"
      :skeleton="isLoadingAsyncData"
      sortable-positions
      @change:pagination="onChangePagination"
      @change:sortable-positions="onUpdatePositions"
      @change:sort="onChangeSort"
      @action:delete="onDeleteWithRefresh"
    />
  </BLayoutList>
</template>

<script>
import { lkTopicPermissions as Permissions } from '@/helpers/enums/permission-models'
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { TopicModel as Model } from './Model'
import { topicsStoreModule as StoreModule } from './store'
import { TOPICS_ROUTES as ROUTES } from './utils'

import BLayoutList from '@/components/layouts/BLayoutList.vue'
import BTableCommon from '@/components/tables/BTableCommon.vue'
import BMenuMore from '@/components/common/BMenuMore.vue'
import ComponentFilter from './components/TopicsFilter.vue'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

const MENU_SELECTED = {
  DELETE: { id: 'delete', title: 'Удалить выбранные' },
}

/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'ViewTopicsList',
  components: {
    BLayoutList,
    BTableCommon,
    BMenuMore,
    ComponentFilter,
  },
  mixins: [
    listMixin,
  ],
  data: () => ({
    selected: [],
    menuSelected: Object.values(MENU_SELECTED),
  }),
  computed: {
    createRoute() {
      const editable = this.$access(Permissions.create)
      return editable ? { name: ROUTES.CREATE } : void 0
    },
  },
  /** @type { List } */
  methods: {
    async onSelectMenu(data) {
      switch (data.id) {
        case MENU_SELECTED.DELETE.id:
          await this.onDeleteMultipleWithRefresh(this.selected)
          break

        default:
      }

      this.selected = []
    },
  },
}
</script>
